import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '30vh', backgroundColor: '#69696930' }}>
      <div style={{ textAlign: 'center', paddingTop: '40px' }}>
        <img src="/img/logo-tsg.svg" alt="Logo" width={120} />
      </div>
      <div>
        <div className="container py-5">
          <div className="row">
            <div className="col-md-4 col-12 px-4">
              <h3 className="sub-section-title" style={{ color: '#000' }}>
                Transport SG
              </h3>
              <p className="text-small" style={{ color: '#000' }}>
                {t('footerText')}
              </p>
            </div>
            <div className="col-md-4 col-12 px-4">
              <h3 className="sub-section-title" style={{ color: '#000' }}>
                {t('contactUs')}
              </h3>
              <p className="text-small" style={{ color: '#000' }}>
                2264 Av. de la Rotonde, Charny, QC G6X 2L8
              </p>
              <p
                className="text-small"
                style={{ marginTop: '-12px', color: '#000' }}
                onClick={() => {
                  window.location.href = 'tel:+14188055969';
                }}
              >
                418-805-5969
              </p>
              <p className="text-small" style={{ color: '#000' }}></p>
            </div>
            <div className="col-md-4 col-12 px-4">
              <h3 className="sub-section-title" style={{ color: '#000' }}>
                {t('utilityLinks')}
              </h3>
              <p
                className="text-small"
                style={{ color: '#000', cursor: 'pointer' }}
                onClick={() => navigate('/terms')}
              >
                {t('terms')}
              </p>
              <p
                onClick={() => navigate('/privacy')}
                className="text-small"
                style={{ color: '#000', marginTop: '-12px', cursor: 'pointer' }}
              >
                {t('privacy')}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div
          style={{
            backgroundColor: '#000',
            color: '#fff',
            textAlign: 'center',
            padding: '10px',
            cursor: 'pointer',
          }}
          onClick={() => (window.location.href = 'https://usenode.com')}
        >
          <img src="./img/icon-node-grey.png" height={8} alt="Node" />
          <p style={{ fontSize: '9px' }}>
            {t('copyRightText')} - {new Date().getFullYear()} ©
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
